import React, { useEffect } from "react";
import { Form, Select, InputNumber } from "antd";

import { elvis } from "../../Utils";

const { Option } = Select;

// Italian Civil Protection 0–5 damage scale (same as DamageChurchForm).
const DAMAGE_SCALES = [
    { value: "ABSENT",      label: "0 — Absent" },
    { value: "LOW",         label: "1 — Low" },
    { value: "MODERATE",    label: "2 — Moderate" },
    { value: "SEVERE",      label: "3 — Severe" },
    { value: "VERY_SEVERE", label: "4 — Very severe" },
    { value: "COLLAPSE",    label: "5 — Collapse" },
];

/**
 * "Struttura collassata" shortcut for any building, like the churches' one:
 * an overall assessment recorded as a whole-structure damage instead of a
 * per-element breakdown.
 */
const CollapsedStructureDamageForm = props => {
    const [form] = Form.useForm();
    const isEditMode = props.isEditMode || false;

    useEffect(() => {
        if (props.record.damage) {
            form.setFieldsValue({
                damageScale: props.record.damage.damageScale,
                extensionPercent: props.record.damage.extensionPercent,
            });
        }
    }, [props.record.damage, form]);

    const onFieldsChange = () => {
        if (!isEditMode) return;
        const values = form.getFieldsValue();
        const newDamage = { ...props.record };
        newDamage.damage.damageDiscriminator = "WHOLE_STRUCTURE";
        newDamage.damage.damageScale = elvis(values.damageScale);
        newDamage.damage.extensionPercent = elvis(values.extensionPercent);
        newDamage.valid = true;
        props.parentCallback(newDamage);
    };

    return (
        <Form
            form={form}
            layout="horizontal"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            className="details_form"
            name="collapsedStructureDamageForm"
            onFieldsChange={onFieldsChange}
        >
            <Form.Item label="Damage scale" name="damageScale">
                <Select allowClear disabled={!isEditMode}>
                    {DAMAGE_SCALES.map(opt => (
                        <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                    ))}
                </Select>
            </Form.Item>
            <Form.Item label="Damage extension (%)" name="extensionPercent">
                <InputNumber min={0} max={100} disabled={!isEditMode} />
            </Form.Item>
        </Form>
    );
};

export default CollapsedStructureDamageForm;
